var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SummaryBudgetView',{attrs:{"columns-to-summary":_vm.columnsToSummary,"over-condition-obj":_vm.overConditionObj,"chart-data":_vm.getPowerSumValues}})}
var staticRenderFns = []

export { render, staticRenderFns }